import { render, staticRenderFns } from "./DiscountsAll.vue?vue&type=template&id=2d7690ba&scoped=true&"
import script from "./DiscountsAll.vue?vue&type=script&lang=js&"
export * from "./DiscountsAll.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsAll.vue?vue&type=style&index=0&id=2d7690ba&lang=scss&scoped=true&"
import style1 from "./DiscountsAll.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7690ba",
  null
  
)

export default component.exports